import { defineView } from "@/ReactSetup/view-definitions";

const definition = defineView({
    name: "CheckoutUserInfo",
    component: () => (__SERVER__ ? require("./checkout-user-info-view") : import("./checkout-user-info-view"))
});

export default definition;
